import React, { useState, useRef, useEffect} from 'react';
import * as ReactBootstrap  from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {handleMessage} from './attendee_actions';
import {flagMessage} from './organizer_options';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton';
import 'bootstrap/dist/css/bootstrap.css';
import {firestore} from './firebaseConfig';
import {useSessionState} from './reusableHooks';

let replies = {};
function useMessages(sessionId) {
    const [messages,setMessages] = useState([]);

    useEffect(() => {
        if(sessionId) {
        const unsubscribe = firestore
                .collection('meetings/' + sessionId + '/messages/').where("flagged", "==", false).orderBy("timestamp")
                .onSnapshot((snapshot) => {
                    replies = {}
                    const newMessages = snapshot.docs.map((doc) => {
                        if(doc.data().reply) {
                            let arr = []
                            if(replies[doc.data().receivingMsgId]) arr = replies[doc.data().receivingMsgId]
                            arr.push({
                                messageID: doc.id,
                                senderId: doc.data().senderId,
                                text: doc.data().text,
                                timestamp: (new Date(doc.data().timestamp.seconds*1000)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
                                fromAdmin: doc.data().fromAdmin,
                                reply: doc.data().reply,
                                receivingUserId: doc.data().receivingUserId,
                                receivingMsgId: doc.data().receivingMsgId
                            })
                            replies[doc.data().receivingMsgId] = arr;
                        }
                        return {
                        messageID: doc.id,
                        senderId: doc.data().senderId,
                        text: doc.data().text,
                        timestamp: (new Date(doc.data().timestamp.seconds*1000)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
                        fromAdmin: doc.data().fromAdmin,
                        reply: doc.data().reply,
                        receivingUserId: doc.data().receivingUserId,
                        receivingMsgId: doc.data().receivingMsgId
                    }})
                    setMessages(newMessages);
                    //console.log(replies)
                })
            return () => unsubscribe();  
        }
    }, [sessionId]); 
    
    return messages;
}


function useOrganizedMessages(sessionId, unorganizedMessages) {
    const [messages,setMessages] = useState([]);

    useEffect(() => {
        if(sessionId && unorganizedMessages) {
            const newMessages = [];
            unorganizedMessages.forEach((doc) => {
                if(!doc.reply) {
                    newMessages.push(doc);
                    if(replies[doc.messageID]) {
                        replies[doc.messageID]?.forEach((reply) => {newMessages.push(reply)})
                    }
                }
            })

            setMessages(newMessages);
            //console.log(newMessages)
        }
    }, [sessionId, unorganizedMessages])

    return messages;
}


export default function Chat({sessionId, thisUser, isAdmin, isSessionChatOn, windowSize,radioValue, checkButton}) {
    const activeSession = useSessionState(sessionId);
    const sessionChatOn = isSessionChatOn; 
    const [individualChatOn, toggleIndividualChat] = useState((false));
    const unorganizedMessages = useMessages(sessionId);
    const messages = useOrganizedMessages(sessionId, unorganizedMessages)

    const textfeedRef = useRef();
    const buttonRef = useRef();
    const textstreamRef = useRef();
    const textareaRef = useRef();
    const [spamError, showSpamError]  = useState({state: "invisible", message: ""});

    const [modalShow, setModalShow] = useState(false);
    const replyRef = useRef();

    const mountedRef = useRef(false);
    
    //Switch between clicker and chat components
    useEffect(() => {
        if(windowSize.width < 600){
            toggleIndividualChat(radioValue==='2')
            if(sessionChatOn === 1){
                if(!individualChatOn) buttonRef.current.style.transform = "rotate(0deg)";
                else buttonRef.current.style.transform = "rotate(180deg)"
            }
        }
    },[radioValue,windowSize, sessionChatOn, individualChatOn])

    useEffect(() => {
        if(individualChatOn) scrollToBottom();
    }, [messages, individualChatOn])

    const toggleTextfeed = () => {
        if(!individualChatOn) buttonRef.current.style.transform = "rotate(180deg)";
        else buttonRef.current.style.transform = "rotate(0deg)"
        
        const newChatStatus = !individualChatOn;
        toggleIndividualChat(newChatStatus);
    }

    const resetTextarea = () => {
        textareaRef.current.value = '';
    }

    const scrollToBottom = () => {
        const textstreams = document.getElementById("textstreams");
        if(textstreams) {
            textstreams.scrollTop = textstreams.scrollHeight;
        }
    }

    const handleClickSend = () => {
        const inputText = textareaRef.current.value;
        if (inputText !== '' && inputText.trim()) {
            handleMessage(inputText, sessionId, thisUser.uid, isAdmin, false, null, null)
            .then(() =>{
                console.log("Message sent.");
                resetTextarea();
                showSpamError({state: "invisible", message: ""});
            })
            .catch((error) => {
                if(error === "duplicate-messages") showSpamError({state: "d-block", message: "You already sent that text!"})
                else if(error === "too-many-messages") showSpamError({state: "d-block", message: "You're sending too many messages at the same time!"})
                console.error("Error sending message: ", error);
            });
        }
    }

    const handleFlag = (event) => {
        flagMessage(sessionId, event.target.id);
    }

    /////reply modal

    const [replyingTo, setReplyingTo] = useState({
        text: "",
        id: "",
        userId: ""
    });

    const handleReply = (event) => {
        //reply to comment event.target.id
        //open modal
        if(mountedRef.current) {
            setReplyingTo(
                {
                id: event.target.id,
                text: event.target.getAttribute("text"),
                userId: event.target.getAttribute("userid")
                }
            );
            setModalShow(true);
        }
    }

    const handleClose = () => {
        if(mountedRef.current) setModalShow(false); 
      };

    const handleSendReply = () => {
        handleMessage(replyRef.current.value, sessionId, thisUser.uid, isAdmin, true, replyingTo.userId, replyingTo.id)
        handleClose();
    };

    /////reply modal

    const handleKeyPress = (e, reply) => {
        if(e.charCode==13){
            e.preventDefault();
            if(reply) handleSendReply()
            else handleClickSend();
          } 
    }

    useEffect(() => {
        mountedRef.current = true;
        return () => {mountedRef.current = false}
      }, [])
    

    return (
        <>  {(sessionChatOn === 1 || sessionChatOn === 2) && individualChatOn &&
            <>
            {individualChatOn &&
            <div id="textfeed" ref={textfeedRef} className="shadow no-left-shadow">
                    <ToggleButtonGroup type="radio" name="toggleChat1" defaultValue={2} aria-label="Toggle Chat Buttons" className="clickerheader-sm h-auto">
                        <ToggleButton variant="secondary" id="radio-show-clicker" value={1} aria-label="Switch to clicker" className="mx-0 mt-0 clickerheader-sm left"
                        onClick={(e) => (checkButton(e.target.value))}>
                        Clicker
                        </ToggleButton>
                        <ToggleButton variant="secondary" id="radio-show-chat" value={2} aria-label="Switch to chat" className="mx-0 mt-0 clickerheader-sm right" 
                        onClick={(e) => (checkButton(e.target.value))}>
                        Chat
                        </ToggleButton>
                    </ToggleButtonGroup>
                    <div id="textstreams" ref={textstreamRef}> 
                        {sessionChatOn === 2 && isAdmin === false && <p>Only administrators can see your messages.</p>}
                        {messages.map((message) => {
                            const color = message.fromAdmin? "" : ""; //highlights admin message
                            const replyIndent = message.reply? " pl-3" : "";
                            if(isAdmin) {
                                if(message.fromAdmin) {
                                    return <p id={message.messageID} key={message.messageID} className={color +  " pr-5" + replyIndent}>
                                        <span className="message-time">{message.timestamp}</span>
                                        <span className={(thisUser.uid === message.senderId)? "font-weight-bold" : ""}>
                                            <span className={message.reply? "text-danger" : ""}>{message.reply? "(Private) " : "(Admin) "}</span>
                                            {message.text}
                                        </span>
                                    </p>
                                }
                                else {
                                    return <p key={message.messageID} className={color + " pr-5"}>
                                        <span className="message-time">{message.timestamp}</span>
                                        <span className="">{message.text}</span>
                                        <span className="comment-options">
                                            {/* reply function*/}
                                            {(thisUser.uid !== message.senderId && sessionChatOn === 2) && <i userid={message.senderId} id={message.messageID} text={message.text} title="Click to reply" className="fas fa-reply reply-option pr-3" onClick={handleReply}></i>}
                                            {(thisUser.uid !== message.senderId) && <i id={message.messageID} title="Click to flag" className="far fa-flag flag-option" onClick={handleFlag}></i>}
                                        </span>
                                    </p>
                                }
                            }
                            else {
                                if(sessionChatOn === 1 && message.fromAdmin) {
                                return <p key={message.messageID} id={message.messageID} className={color + replyIndent}>
                                    <span className="message-time">{message.timestamp}</span>
                                    <span className="">{"(Admin) " + message.text}
                                    </span>
                                </p>
                                }
                                else if(sessionChatOn === 1) {
                                    return <p key={message.messageID} id={message.messageID} className={color + replyIndent}>
                                    <span className="message-time">{message.timestamp}</span>
                                    {(thisUser.uid === message.senderId) && <span className="font-weight-bold">{message.text}</span>}
                                    {(thisUser.uid !== message.senderId) && <span className="">{message.text}</span>}
                                </p>
                                }
                                else if(sessionChatOn === 2 && (thisUser.uid === message.senderId || (message.fromAdmin && !message.reply) || (message.receivingUserId === thisUser.uid))) {
                                    return <p key={message.messageID} id={message.messageID} className={color + replyIndent}>
                                        <span className="message-time">{message.timestamp}</span>
                                        {message.fromAdmin? 
                                            <span>
                                                <span className={message.reply? "text-danger" : ""}>{message.reply? "(Private) " : "(Admin) "}</span>
                                                {message.text}
                                            </span>
                                            : 
                                            <span className="font-weight-bold"> {message.text}</span>
                                        }
                                        </p>
                                }
                            }
                        })}
                    </div>
                    <div id="textinput" className={(!activeSession? "disabled" : "")} disabled={!activeSession} 
                            data-tooltip={activeSession? "" : "Thank you for participating in this test of new technology to share your thoughts on the proposed changes to Kendrick Park."}>
                        <span className="textarea-wrapper d-flex flex-row mb-1">
                            <textarea id="textarea" ref={textareaRef} type="text" onKeyPress={(e) => handleKeyPress(e, false)} 
                            className="my-0 h-100" disabled={!activeSession}></textarea>
                            <ReactBootstrap.Button id="sendtext" className="my-0 h-100" onClick={handleClickSend} disabled={!activeSession}>
                            Send
                            </ReactBootstrap.Button>
                        </span>
                        <p id="spam-error" className={spamError.state + " mt-1 mb-3 text-danger"}>{spamError.message}</p>
                    </div>
            </div>
            }
            </>
            }
            {(sessionChatOn === 1 || sessionChatOn === 2) &&
            <>
            <div id="textboxtoggle" ref={buttonRef} onClick={toggleTextfeed}>
                <FontAwesomeIcon  className="fa-3x" icon={faCaretRight} id="textgobutton"/>
            </div>
            </>
            }

            {/*reply modal*/}
            <Modal show={modalShow} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className="" style={{fontWeight: "normal"}}>
                            "{replyingTo.text}"
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="replyText">
                        <Form.Control as="textarea" ref={replyRef} rows={3} placeholder="Your reply..." onKeyPress={(e) => handleKeyPress(e, true)} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="primary" onClick={handleSendReply}>
                    Send
                 </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
